import { pageIdInfos } from '@/Providers'

export const GlobalLoadingSpinnerDisabledPagePath = new Set<string>([
  pageIdInfos.move_log.url,
  pageIdInfos.move_log_insight.url,
  pageIdInfos.step_counter.url,
  pageIdInfos.step_counter_terms_withdrawal.url,
  pageIdInfos.vertical_poi_search.url,
  pageIdInfos.vertical_poi_category.url,
])
